<section class="has-padding-block-1 animated fadeIn">
  <div class="row">
    <div class="col-sm-3 d-none d-sm-block">
      <img src="../../../assets/images/landing/how-it-works/PFW Box.webp" class="img-side is-height-2"
        alt="Sustainable Packaging image">
    </div>
    <div class="col-sm-9">
      <h2 class="section-title">Product tags make it easy to find products that meet your values, sustainability goals,
        and dietary needs.</h2>
      <p>Philly Foodworks product tags appear on the bottom of each product card on the market. The tag's name is
        visible when you hover over the icon. You can use the sidebar filter to explore and filter products by
        packaging, dietary preferences, production methods, who made them, and distance from Philadelphia.</p>
    </div>
    <div class="col-sm-3 d-block d-sm-none">
      <img src="../../../assets/images/landing/how-it-works/PFW Box.webp" class="img-side is-height-2"
        alt="Sustainable Packaging image">
    </div>
  </div>
</section>
<hr class="is-thick">
<div class="banner-title-wrap is-center mt-3 mb-5">
  <div class="banner-title is-primary ">Curious about our product tags (the icons below the "add" button on our product
    cards)? Check out the guide below to see what they mean!</div>
</div>
<p>We are especially excited about our packaging tags. These tags convey what kind of packaging is used and will assist
  you in reducing packaging waste. Together with our existing options, they empower you to shop harmoniously with your
  values.</p>


<div>
  <h3 class="h3-bold">Packaging</h3>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/packaging-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Package-Free</h3>
      Products with this tag do not require any individual packaging.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/plastic-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Plastic-Free</h3>
      These items may have disposable packaging but are confirmed not to have any plastic material included in their
      packaging. You can purchase these items with the peace of mind that you are not contributing to plastic waste!
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/glass.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Glass</h3>
      These items have a 100% recyclable and food-safe glass component to their packaging. If an item has this tag and
      the recyclable tag, you can safely recycle the entire package after use.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/returnable.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Returnable</h3>
      These items are shipped in returnable packaging and can be returned with your next delivery! Learn more about our
      sustainable packaging system <a routerLink="/pages/about-us/packaging">here</a>.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/reusable.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Reusable</h3>
      These products come in resealable packaging and can be repurposed! Many of Philly Foodworks’ providers use
      high-quality packaging durable enough for several uses.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/recyclable.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Recyclable</h3>
      Not all plastic, paper, or cardboard packaging is recyclable! These products explicitly disclose if the packaging
      is recyclable.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/upcycled.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Upcycled</h3>
      These products are made from post-consumer recycled materials, contributing to a circular economy and avoiding
      excess plastic production.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/packaging/compostable-at-home.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Compostable at Home</h3>
      These products are suitable for at-home composting. After the labeling is removed, the packaging materials can be
      added to your compost pile or sent to a composting facility! Please note that not all “compostable” materials can
      be composted at home or with a local composting facility.
    </div>
  </div>
</div>
<hr class="is-thin">
<div>
  <h3 class="h3-bold">Mileage</h3>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/mileage/made-in-philly.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Made In Philly</h3>
      These products are proudly made in Philadelphia!
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/mileage/75-miles.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">75 Miles</h3>
      These products are made or grown within a 75 mile radius of PFW.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/mileage/150-miles.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">150 Miles</h3>
      These products are made or grown within a 150 mile radius of PFW.
    </div>
  </div>
</div>
<hr class="is-thin">
<div>
  <h3 class="h3-bold">Dietary</h3>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/gluten-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Gluten-Free</h3>
      Products with this tag are gluten free.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/kosher.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Kosher</h3>
      Products with this tag are considered Kosher by the producer.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/non-dairy.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Non-Dairy</h3>
      Products with this tag do not contain any dairy products.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/non-GMO.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Non-GMO</h3>
      Products with this tag are not and do not contain any GMO ingredients.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/seed-oil-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Seed Oil-Free</h3>
      Products with this tag do not contain any seed oil.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/soy-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Soy-Free</h3>
      Products with this tag are soy free.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/vegan.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Vegan</h3>
      Products with this tag are considered vegan by the producer.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/dietary/vegetarian.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Vegetarian</h3>
      Products with this tag are considered vegetarian by the producer.
    </div>
  </div>
</div>
<hr class="is-thin">
<div>
  <h3 class="h3-bold">Production</h3>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/antibiotic-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Antibiotic-Free</h3>
      Products with this tag are free from hormones and antibiotics.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/chemical-free.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Chemical-Free</h3>
      Products with this tag are crops grown without any chemicals.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/hydroponic.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Hydroponic</h3>
      Products with this tag are items grown hydroponically.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/IPM.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">IPM</h3>
      Products with this tag are grown using IPM methods. IPM stands for Integrated Pest Management. These practices are
      meant to limit the use of pesticides and can include but aren't limited to beneficial insects, trapping harmful
      insects, and the use of insect pheromones to disrupt insect mating, to name a few.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/naturally- grown.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Naturally Grown</h3>
      Products labeled with this tag are cultivated by dedicated farmers who prioritize chemical-free and pesticide-free
      methods through regenerative practices. Remarkably, many of these farmers meet and often surpass organic
      standards. This choice stems from the challenges posed by organic certification costs, highlighting their
      commitment to sustainable agriculture.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/organic.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Organic</h3>
      Products labeled with this tag are grown using Organic methods. The farm has obtained organic certification.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/pastured.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Pastured</h3>
      Products with this tag are raised on open pastures.
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/production/wild-caught.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Wild Caught</h3>
      Products with this tag are sustainably & wild-caught fish.
    </div>
  </div>
</div>
<hr class="is-thin">
<div>
  <h3 class="h3-bold">Ownership</h3>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/ownership/woman-owned.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Woman Owned</h3>
      These products are proudly made by a woman-owned company!
    </div>
  </div>
  <div class="ul-img-list">
    <span class="list-img">
      <img src="../../../assets/images/landing/how-it-works/product-tags/ownership/black-POC-owned.jpg">
    </span>
    <div class="list-content">
      <h3 class="list-title">Black/POC Owned</h3>
      These products are proudly made by a person of color owned company!
    </div>
  </div>
</div>
